import Lottie from "lottie-react";
import React from "react";
import loading from "../../assets/lottie/loading_page.json";
import logo from "../../assets/logo/diskominfo.png";

export default function LoadingPage() {
  return (
    <div>
      <div className="w-screen h-screen absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
        <div className="flex flex-col justify-center items-center">
          <div>
            <img src={logo} className="h-28" alt="logo Kerjasama Media Media Online" />
          </div>
          <div className="w-64">
            <Lottie animationData={loading} loop={true} />
          </div>
        </div>
      </div>
    </div>
  );
}
